import { render, staticRenderFns } from "./RepairAssessmentDetail.vue?vue&type=template&id=5601a54e&scoped=true"
import script from "./RepairAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./RepairAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./RepairAssessmentDetail.vue?vue&type=style&index=0&id=5601a54e&prod&lang=scss&scoped=true"
import style1 from "./RepairAssessmentDetail.vue?vue&type=style&index=1&id=5601a54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601a54e",
  null
  
)

export default component.exports